import { Route, Switch, useParams } from 'react-router-dom';
import { subroutes } from './navigation';
import { PageSizing } from '__components/Layout/PageContentWidth';
import { ContentWidth } from '__components/Layout/PageContentWidth';
import { ControlBar } from './ControlBar';
import { useDispatch } from 'react-redux';
import { useAsync } from 'react-use';
import SmartConnectorService from 'services/SmartConnectorService';
import {
  SmartConnector,
  SmartConnectorMetaData,
} from '__pages/SmartConnectors/types';
import { setError } from 'store/errors';
import { useCallback, useState } from 'react';
import { useSmartConnectorAccess } from '__pages/SmartConnectors/hooks/useSmartConnectorAccess';
import Loader from '__components/Kizen/Loader';
import { StyledPage } from './styles';
import { useSmartConnectorTitle } from '../hooks/useSmartConnectorTitle';

export const SmartConnectorSettingsPage = () => {
  const params = useParams<{ id: string; subpage: string }>();
  const [smartConnector, setSmartConnector] = useState<SmartConnector>();
  useSmartConnectorTitle(smartConnector);
  const { id } = params;

  const { smartConnectorAccess } = useSmartConnectorAccess(
    smartConnector?.owner?.id
  );

  const dispatch = useDispatch();

  const [runKey, setRunKey] = useState(0);

  const onStartRun = useCallback(() => setRunKey((prev) => prev + 1), []);

  const { value: metaData = null, loading } = useAsync(async () => {
    try {
      const [smartConnectorResponse, metadataResponse] = await Promise.all([
        SmartConnectorService.getSmartConnector(id),
        SmartConnectorService.getSmartConnectorMetaData(),
      ]);
      setSmartConnector(smartConnectorResponse.data);

      return metadataResponse.data as SmartConnectorMetaData;
    } catch (err: any) {
      if (err.isAxiosError) {
        dispatch(setError({ code: err.response?.status }));
      }
    }
  }, [id]);

  return (
    <StyledPage>
      <Loader loading={loading}>
        {smartConnector && metaData ? (
          <>
            <ControlBar
              smartConnector={smartConnector}
              access={smartConnectorAccess}
              onStartRun={onStartRun}
            />
            <PageSizing>
              <ContentWidth>
                <Switch>
                  {Object.values(subroutes).map(
                    ({ component: Component, path, exact }) =>
                      Component ? (
                        <Route
                          key={path}
                          path={path}
                          exact={exact !== false}
                          render={() => (
                            <Component
                              smartConnector={smartConnector}
                              setSmartConnector={setSmartConnector}
                              access={smartConnectorAccess}
                              metaData={metaData}
                              runKey={runKey}
                            />
                          )}
                        />
                      ) : null
                  )}
                </Switch>
              </ContentWidth>
            </PageSizing>
          </>
        ) : null}
      </Loader>
    </StyledPage>
  );
};
